import { render } from "./Shipyard.vue?vue&type=template&id=24b3a263&scoped=true"
import script from "./Shipyard.vue?vue&type=script&lang=js"
export * from "./Shipyard.vue?vue&type=script&lang=js"

import "./Shipyard.vue?vue&type=style&index=0&id=24b3a263&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b3a263"]])

export default __exports__